// extracted by mini-css-extract-plugin
export var productImage = "_107-0";